import React from 'react';

const PopupContent: React.FC<{ children: React.ReactNode }> = (props) => {
  return <div>{props.children}</div>;
};

export default PopupContent;
